import instance, { BaseUrl } from "./InstanceAxios";
import axios from "axios";
const getAllPlace = async () => {
  const res = await instance.get("/api/places/list");

  return res;
};
const getAllTour = async () => {
  const res = await instance.get("/api/tours/list");
  return res;
};
const getAllFaq = async () => {
  const res = await instance.get(`/api/faq/list?v2`);
  return res;
};
const postAddPlace = async (placeData: any) => {
  const res = await instance.post("/api/places/create", placeData);
  return res;
};
const postAddFaq = async (faqData: any) => {
  const res = await axios(`${BaseUrl}/api/faq/create`, {
    // await instance.post("/api/faq/create",{
    method: "post",
    data: {
      tourId: faqData?.tourId,
      name: faqData?.filterName,
      question: [
        {
          topQuestion: faqData?.question,
          description: faqData?.answer,
        },
      ],
    },
  });

  return res;
};
// delete faq
const removeAddFaq = async (id: any) => {
  const res = await axios(`${BaseUrl}/api/faq/delete/${id}`, {
    // await instance.post("/api/faq/create",{
    method: "delete",
    data: {},
  });
  return res;
};
// reviews get reviews api
const allReviews = async () => {
  const res = await instance.get("/api/review/list");
  return res;
};
// post add reviews api
const postAddReviews = async (reviewData: any) => {
  const res = await instance.post("/api/review/create", {
    status: 1,
    ...reviewData,
  });
  return res;
};
// delete reviews
const deleteReviews = async (id: any) => {
  const res = instance.delete(`/api/review/delete/${id}`);
  return res;
};

// Fetch all review sources
const getAllReviewSources = async () => {
  const res = await instance.get("/api/reviewSource/list");
  return res;
};

// Fetch a single review source by ID
const getReviewSourceById = async (id: string) => {
  const res = await instance.get(`/api/reviewSource/list/${id}`);
  return res;
};

// Create a new review source
const postReviewSource = async (reviewData: any) => {
  const res = await instance.post("/api/reviewSource/create", {
    status: 1,
    ...reviewData,
  });
  return res;
};

// Update an existing review source by ID
const editReviewSource = async (id: string, reviewData: any) => {
  const res = await instance.put(`/api/reviewSource/update/${id}`, reviewData);
  return res;
};

// Delete a review source by ID
const deleteReviewSource = async (id: string) => {
  const res = await instance.delete(`/api/reviewSource/delete/${id}`);
  return res;
};

// post add admin api
const adminPost = async (adminData: any) => {
  const res = await instance
    .post(`${BaseUrl}/api/admin/inviteAdmin`, {
      email: adminData?.email,
    })
    .then((response: any) => {
      if (response.status === 200) {
        alert("Email added successfully");
        return response;
      }
    })
    .catch((error: any) => {
      console.error("error",error)
    });

  return res;
};
// add bundles
const postAddBundles = async (bundlesData: any) => {
  const res = await axios(`${BaseUrl}/api/review/create`, {
    // await instance.post("/api/faq/create",{
    method: "post",
    data: {
      name: bundlesData?.name,
      imageUrl: bundlesData?.imageUrl,
      retailPrice: bundlesData?.retailPrice,
      sellingPrice: bundlesData?.sellingPrice,
      description: bundlesData?.description,
      status: bundlesData?.status,
    },
  })
    .then((response: any) => {
      if (response.status === 200) {
        alert("Reviews added successfully");
        return response;
      }
    })
    .catch((error: any) => {
      console.error("error",error)
    });

  return res;
};
//get user
export const getUser = async (params: {
  page: number;
  pageSize: number;
  search?: string;
}) => {
  const response = await instance.get(`/api/user/list`, { params });
  return response.data; // { data: [], pagination: {} }
};

//getUsersEmail
export const getUsersEmail = async(params: {type: 'all' | 'range' | string, startDate: string | null, endDate: string | null}) => {
  const response = await instance.post(`api/admin/getUsersEmail`, params);
  return response.data
}

// Master-admin check for the Export Users button (8 Sep 2026): the server
// decides; the UI only hides the button when the answer is no.
export const exportAccess = async (): Promise<{ status: boolean; allowed: boolean }> => {
  const response = await instance.get(`api/admin/exportAccess`);
  return response.data;
};

//add article
const postAddArticle = async (articData: any) => {
  const res = await axios(`${BaseUrl}/api/articles/create`, {
    method: "post",
    data: {
      topicId: 1,
      name: articData?.name,
      imageUrl: articData?.imageUrl,
      profileUrl: articData?.profileUrl,
      title: articData?.title,
      description: articData?.description,
    },
  });

  return res;
};
const deletearticle = async (id: any) => {
  try {
    const res = await instance.delete(`/api/articles/delete/${id}`);
    return res;
  } catch (err) {
    return err;
  }
};
const editArticle = async (id: any, payload: any) => {
  try {
    const res = await instance.put(`/api/articles/update/${id}`, payload);
    return res;
  } catch (err) {
    return err;
  }
};
const editFaq = async (id: any, payload: any) => {
  try {
    const res = await instance.put(`/api/faq/update/${id}`, payload);
    return res;
  } catch (err) {
    return err;
  }
};
const editReviews = async (id: any, payload: any) => {
  try {
    const res = await instance.put(`/api/review/update/${id}`, payload);
    return res;
  } catch (err) {
    return err;
  }
};
const getTopicList = async () => {
  const res = await instance.get("/api/topic/list");
  return res;
};

const adminLogIn = async (payload: any) => {
  try {
    const res = await instance.post("/api/admin/logIn", payload);
    return res;
  } catch (error) {
    return error;
  }
};
const editUser = async (payload: any) => {
  try {
    const res = await instance.put("/api/user/edit", payload);
    return res;
  } catch (error) {
    return error;
  }
};

const createUserApi = async (payload: any) => {
  const res = await instance.post("/api/cart/createUser", payload);
  return res?.data;
};

const deleteUserApi = async (id: any) => {
  const payload = {
    id: id,
  };

  try {
    const response = await instance.delete(`/api/user/delete`, {
      data: payload,
    });

    console.log("deleteUser response: ", response);

    return response.data;
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
};

const userTourList = async (userId?: any) => {
  const res = await instance.post(`/api/getUserToursList`, {
    id: userId,
  });
  return res.data;
};

const getUserProfile = async (userId: string) => {
  const res = await instance.get(`/api/admin/user-profile/${userId}`);
  return res.data;
};

// get api for all bundles

const getBundles = async () => {
  const res = await instance.get("/api/bundles/list?isAdmin");

  return res;
};

const getActiveBundles = async () => {
  const res = await instance.get("/api/bundles/list");

  return res;
};

// create bundle api
const createBundles = async (payload: any) => {
  const res = await instance.post("/api/bundles/create", payload);
  return res;
};
// update bundle api
const updateBundles = async (payload: any) => {
  const res = await instance.put("/api/bundles/update", payload);
  return res;
};

const getAdmins = async () => {
  const res = await instance.get("/api/admin/getAllAdminInfo");

  return res;
};
const inviteAdmin = async (payload: any, isAuthenticate: any) => {
  const res = await instance.post("/api/admin/inviteAdmin", payload, {
    headers: {
      auth: isAuthenticate,
    },
  });

  return res;
};

const updateOffline = async (id: any) => {
  const res = await instance.get(`/api/tours/updateOffline/${id}`);
  return res;
};

const createAdminPermissions = async (payload: any, id: any) => {
  try {
    const res = await instance.post("/api/admin/subAdminPermissions", {
      ...payload,
      id: id,
    });
    return res;
  } catch (err) {
    return err;
  }
};
const updateAdminPermissions = async (payload: any, id?: any) => {
  try {
    const res = await instance.put(`/api/admin/editPermissions/${id}`, payload);
    return res;
  } catch (err) {
    return err;
  }
};
///api/admin/subAdminPermissions
const createTopics = async (payload: any) => {
  const res = await instance.post("/api/topic/create", payload);

  return res;
};

const articlesList = async () => {
  const res = await instance.get("/api/articles/list");

  return res;
};

const singletourList = async (endpiont?: any) => {
  const res = await instance.post(`/api/tours/list`, { tourId: endpiont });
  return res.data;
};
const createStops = async (payload: any) => {
  const res = await instance.post(`/api/tourPoints/create`, payload);
  return res.data;
};
const createTours = async (payload: any) => {
  const res = await instance.post(`/api/tours/create`, payload);
  return res;
};

const deleteMailData = async (id: number) => {
  const res = await instance.delete(`/api/redeemMail/delete/${id}`);
  return res.data; 
};

const saveMailData = async (id: number, payload: any) => {
  const res = await instance.post(`/api/redeemMail/save/${id}`, payload);
  return res.data;
};

const getAllMailData = async (type:any) => {
  const res = await instance.get(`/api/redeemMail/getAll/${type||"redeem"}`);
  return res.data; 
};

const getOtherMails = async () => {
  const res = await instance.get(`/api/redeemMail/getOtherMails`);
  return res.data; 
};

const sendImmediateMail = async (payload:any) => {
  const res = await instance.post(`/api/redeemMail/sendMail`,payload);
  return res.data;
};

// Bookings: resend the tour-code e-mail for one booking (admin only). The
// server re-uses the same Bokun mailer and records the attempt in the
// e-mail record book, so the E-mail column updates within a minute.
const resendCodeMail = async (bookingId: number) => {
  const res = await instance.post(`/api/bookings/resend-code-mail`, { bookingId });
  return res.data;
};

const uploadAudio = async (payload: any, onProgress?: (percent: number) => void) => {
  const formData = new FormData();
  formData.append("audio", payload);
  try {
    const res = await instance.post("api/audiosUpload", formData, {
      onUploadProgress: (e: any) => {
        if (onProgress && e.total) {
          onProgress(Math.round((e.loaded * 100) / e.total));
        }
      },
    });

    return res;
  } catch (error) {
    console.error("error",error)
  }
};
const removeAudio = async (audioUrl: string) => {
  try {
    const res = await instance.delete(
      `/api/tourPoints/deleteAudio?fileName=${encodeURIComponent(audioUrl)}`
    );

    return res;
  } catch (error) {
    console.error("error",error)
  }
};

const uploadImage = async (payload: any) => {
  const formData = new FormData();
  formData.append("image", payload);
  const res = await instance.post("api/imagesUpload", formData);
  return res;
};
const removeImage = async (imageUrl: string) => {
  try {
    const res = await instance.delete(
      `/api/tourPoints/deleteImage?fileName=${encodeURIComponent(imageUrl)}`
    );

    return res;
  } catch (error) {
    console.error("error",error)
  }
};

const deletePlace = async (id: any) => {
  try {
    const res = await instance.delete(`/api/places/delete/${id}`);
    return res;
  } catch (err) {
    return err;
  }
};

const deleteTour = async (id: any) => {
  try {
    const res = await instance.delete(`/api/tours/delete/${id}`);
    return res;
  } catch (err) {
    return err;
  }
};

const deleteBundle = async (id: any) => {
  try {
    const res = await instance.delete(`/api/bundles/delete/${id}`);
    return res;
  } catch (err) {
    return err;
  }
};

const editPlace = async (id: any, payload: any) => {
  try {
    const res = await instance.put(`/api/places/update/${id}`, payload);
    return res;
  } catch (err) {
    return err;
  }
};
const editTous = async (id: any, payload: any) => {
  try {
    const res = await instance.put(`/api/tours/update/${id}`, payload);
    return res;
  } catch (err) {
    return err;
  }
};
const editStop = async (id: any, payload: any) => {
  try {
    const res = await instance.put(`/api/tourPoints/update/${id}`, payload);

    return res;
  } catch (err) {
    return err;
  }
};
const editStopList = async (payload: any) => {
  try {
    const res = await instance.put(`/api/tourPoints/updateList/`, payload);
    return res;
  } catch (err) {
    return err;
  }
};

const deleteStop = async (id: any) => {
  try {
    const res = await instance.delete(`/api/tourPoints/delete/${id}`);

    return res;
  } catch (err) {
    return err;
  }
};

const changePassword = async (payload: any) => {
  try {
    const res = await instance.post("/api/admin/changePassword", payload);

    return res;
  } catch (err) {
    return err;
  }
};
const addSaftyInfo = async (payload: any) => {
  try {
    const res = await instance.post("/api/safetyInfo/create", payload);

    return res;
  } catch (err) {
    return err;
  }
};
const getSaftyInfo = async (id: any) => {
  try {
    const res = await instance.get(`api/safetyInfo/list/${id}`);

    return res;
  } catch (err) {
    return err;
  }
};
const updateSaftyInfo = async (id: any, payload: any) => {
  try {
    const res = await instance.put(`api/safetyInfo/update/${id}`, payload);

    return res;
  } catch (err) {
    return err;
  }
};

///safetyInfo/delete/

const deleteSaftyInfo = async (id: any) => {
  try {
    const res = await instance.delete(`api/safetyInfo/delete/${id}`);
    return res;
  } catch (err) {
    return err;
  }
};

const dashboardAnalytics = async (payload: any) => {
  try {
    const res = await instance.post(`api/admin/analytics`, payload);

    return res;
  } catch (err) {
    return err;
  }
};
//  delete admin user
const deleteAdminUser = async (id: any) => {
  try {
    const res = await instance.delete(`api/admin/delete/${id}`);
    return res;
  } catch (err) {
    return err;
  }
};
// forgot password post api
const forgotPassword = async (payload: any) => {
  try {
    const res = await instance.post("/api/admin/forgotPassword", payload);

    return res;
  } catch (err) {
    return err;
  }
};
// forgot password post api
const resetPassword = async (payload: any, token: any) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `${token}`,
  };
  // Make GET request

  try {
    const res = await axios.post(
      `${BaseUrl}/api/admin/resetPassword`,
      payload,
      { headers }
    );
    return res;
  } catch (err) {
    return err;
  }
};
// get otp post api
const getOtp = async (payload: any) => {
  try {
    const res = await instance.post("/api/admin/verifyOtp", payload);
    return res;
  } catch (err) {
    return err;
  }
};
// tours get api
const getTourSave = async (id: any) => {
  const res = await instance.post(`api/singleTourDirection`, id);
  return res;
};
// const getSingleTourDirection = async (id: any) => {
//   const res = await instance.get(`api//singleTourDirection/${id}`);
//   return res;
// };
const getSingleTourDirection = async (payload: any) => {
  console.log("payload", payload);

  try {
    const res = await instance.post("api/tours/list", payload);
    return res;
  } catch (err) {
    return err;
  }
};



//get bookings list
const getBookings = async (params: {
  page: number;
  limit: number;
  search?: string;
}) => {
  const res = await instance.get("/api/bookings/list",{params});
  return res;
};

// get in-app purchases list (ios + android)
const getAppPurchases = async (params: {
  page: number;
  limit: number;
  search?: string;
  platform?: "all" | "ios" | "android";
}) => {
  const res = await instance.get("/api/payments/appPurchases", { params });
  return res;
};

// dashboard IAP analytics
const getDashboardStats = async (params: { startDate: string; endDate: string }) => {
  const res = await instance.get("/api/admin/dashboard", { params });
  return res;
};

// currency rates (admin-managed FX table)
const getCurrencyRates = async () => {
  const res = await instance.get("/api/currencyRates");
  return res;
};
const updateCurrencyRate = async (currency: string, body: { rateToUSD: number; note?: string }) => {
  const res = await instance.put(`/api/currencyRates/${currency}`, body);
  return res;
};

//videos apis
const getVideoById = async (id: any) => {
  const res = await instance.get("/api/videos/" + id);
  return res;
};
const createVideo = async (payload: any) => {
  const res = await instance.post("/api/videos/", payload);
  return res;
};
const updateVideo = async (payload: any) => {
  const res = await instance.put("/api/videos/", payload);
  return res;
};

const services = {
  getVideoById,
  createVideo,
  updateVideo,
  getAllPlace,
  getAllTour,
  getAllFaq,
  postAddPlace,
  postAddFaq,
  removeAddFaq,
  postAddReviews,
  allReviews,
  deleteReviews,
  adminPost,
  postAddBundles,
  getUser,
  getUsersEmail,
  exportAccess,
  postAddArticle,
  // getAllArticle,
  getAllMailData,
  getOtherMails,
  sendImmediateMail,
  resendCodeMail,
  saveMailData,
  deleteMailData,
  getTopicList,
  adminLogIn,
  editUser,
  getBundles,
  getActiveBundles,
  createBundles,
  updateBundles,
  getAdmins,
  inviteAdmin,
  createTopics,
  articlesList,
  deletearticle,
  singletourList,
  createStops,
  createTours,
  uploadAudio,
  uploadImage,
  deletePlace,
  deleteTour,
  deleteBundle,
  editPlace,
  editTous,
  editStop,
  deleteStop,
  changePassword,
  updateOffline,
  addSaftyInfo,
  getSaftyInfo,
  updateSaftyInfo,
  deleteSaftyInfo,
  dashboardAnalytics,
  createAdminPermissions,
  updateAdminPermissions,
  deleteAdminUser,
  forgotPassword,
  resetPassword,
  getOtp,
  getTourSave,
  editArticle,
  editFaq,
  editReviews,
  getSingleTourDirection,
  createUserApi,
  deleteUserApi,
  userTourList,
  editStopList,
  getBookings,
  getAppPurchases,
  getDashboardStats,
  getCurrencyRates,
  updateCurrencyRate,
  getUserProfile,
  removeAudio,
  removeImage,
  getAllReviewSources,
  getReviewSourceById,
  postReviewSource,
  editReviewSource,
  deleteReviewSource,
};

export default services;
